import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function upsertMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
}

function upsertLink(rel, href) {
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
}

/**
 * Syncs document title, description, html lang, and canonical for the current page.
 * Render one per page.
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @returns {null}
 */
function Seo({ title, description }) {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const canonical = `${window.location.origin}${pathname}`;

    document.title = title;
    document.documentElement.lang = i18n.resolvedLanguage || i18n.language || 'no';

    upsertMeta('meta[name="description"]', { name: 'description', content: description });
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: title });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
    upsertLink('canonical', canonical);
  }, [title, description, pathname, i18n.language, i18n.resolvedLanguage]);

  return null;
}

export default Seo;
